import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { DatatypesTable } from "./components/DatatypesTable";

const Datatypes = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Datatypes");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Datatypes" },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title="Datatypes"
                subtitle="Define data types used by fields"
            />

            <div className="mt-6">
                <DatatypesTable />
            </div>
        </AdminPageContent>
    );
};

export default Datatypes;
